module.exports = __webpack_public_path__ + "static/media/image_blue@2x-min.d86501a9.jpg";